import { render, staticRenderFns } from "./StoreRoles.vue?vue&type=template&id=927a4510&"
import script from "./StoreRoles.vue?vue&type=script&lang=js&"
export * from "./StoreRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports